import { jsx as _jsx } from "react/jsx-runtime";
import { Article } from '../article';
export function EntityArticle({ entity }) {
    return _jsx(Article, {});
}
